export default __webpack_public_path__ + "static/media/EmeraldPokeball.b14049a2.svg";